module.exports = __webpack_public_path__ + "fonts/Amaranth-Bold.03f3bdf4.woff2";